/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monthly_PeriodInputs */

const en_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const id_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulanan`)
};

const ms_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulanan`)
};

const ca_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensual`)
};

const cs_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Měsíčně`)
};

const da_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedlig`)
};

const de_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlich`)
};

const et_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iga kuu`)
};

const es_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensualmente`)
};

const fr_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensuel`)
};

const hr_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mjesečno`)
};

const it_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensile`)
};

const lv_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikmēneša`)
};

const lt_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas mėnesį`)
};

const hu_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Havonta`)
};

const nl_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijks`)
};

const nb_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedlig`)
};

const pl_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miesięcznie`)
};

const pt_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensal`)
};

const ro_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunar`)
};

const sk_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesačne`)
};

const sl_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesečno`)
};

const fi_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuukausittainen`)
};

const sv_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månatligen`)
};

const vi_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hằng tháng`)
};

const tr_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık`)
};

const el_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μηνιαίως`)
};

const bg_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Месечен`)
};

const ru_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячно`)
};

const sr_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Месечно`)
};

const uk_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щомісяця`)
};

const ka_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თვიური`)
};

const hi_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मासिक`)
};

const th_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายเดือน`)
};

const ko_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`월간`)
};

const zh_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月度`)
};

const zh_tw_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月`)
};

const ja_monthly_period = /** @type {(inputs: Monthly_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月間プラン`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Monthly_PeriodInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const monthly_period = /** @type {((inputs?: Monthly_PeriodInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthly_PeriodInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_monthly_period(inputs)
	if (locale === "ms") return ms_monthly_period(inputs)
	if (locale === "ca") return ca_monthly_period(inputs)
	if (locale === "cs") return cs_monthly_period(inputs)
	if (locale === "da") return da_monthly_period(inputs)
	if (locale === "de") return de_monthly_period(inputs)
	if (locale === "et") return et_monthly_period(inputs)
	if (locale === "es") return es_monthly_period(inputs)
	if (locale === "fr") return fr_monthly_period(inputs)
	if (locale === "hr") return hr_monthly_period(inputs)
	if (locale === "it") return it_monthly_period(inputs)
	if (locale === "lv") return lv_monthly_period(inputs)
	if (locale === "lt") return lt_monthly_period(inputs)
	if (locale === "hu") return hu_monthly_period(inputs)
	if (locale === "nl") return nl_monthly_period(inputs)
	if (locale === "nb") return nb_monthly_period(inputs)
	if (locale === "pl") return pl_monthly_period(inputs)
	if (locale === "pt") return pt_monthly_period(inputs)
	if (locale === "ro") return ro_monthly_period(inputs)
	if (locale === "sk") return sk_monthly_period(inputs)
	if (locale === "sl") return sl_monthly_period(inputs)
	if (locale === "fi") return fi_monthly_period(inputs)
	if (locale === "sv") return sv_monthly_period(inputs)
	if (locale === "vi") return vi_monthly_period(inputs)
	if (locale === "tr") return tr_monthly_period(inputs)
	if (locale === "el") return el_monthly_period(inputs)
	if (locale === "bg") return bg_monthly_period(inputs)
	if (locale === "ru") return ru_monthly_period(inputs)
	if (locale === "sr") return sr_monthly_period(inputs)
	if (locale === "uk") return uk_monthly_period(inputs)
	if (locale === "ka") return ka_monthly_period(inputs)
	if (locale === "hi") return hi_monthly_period(inputs)
	if (locale === "th") return th_monthly_period(inputs)
	if (locale === "ko") return ko_monthly_period(inputs)
	if (locale === "zh") return zh_monthly_period(inputs)
	if (locale === "zh-tw") return zh_tw_monthly_period(inputs)
	if (locale === "ja") return ja_monthly_period(inputs)
	return en_monthly_period(inputs)
});